import { useCallback } from 'react'
import { NotifyEventType } from 'enums/app'
import { useAppDispatch } from 'states/hooks'
import { useDeleteEventRecordingTranscribesMutation } from '@crew/apis/eventRecordingTranscribe/eventRecordingTranscribeApis'
import { DeleteEventRecordingTranscribesRequest } from '@crew/apis/eventRecordingTranscribe/models/deleteEventRecordingTranscribes/request'
import { EventRecordingTranscribe } from '@crew/models/domain'
import {
  notifyEventRecordingTranscribeEvent,
  ObjectEventMessage,
} from 'features/app/states/appSlice'
import { SelectedEventRecordingTranscribe } from 'features/event/components/eventDetailPage/useEventDetailPage'

export const useEventDetailMeetingMinutesToolbar = (eventId: string) => {
  const dispatch = useAppDispatch()

  const [
    deleteEventRecordingTranscribesMutation,
    { isLoading: isLoadingDeleteTranscribes },
  ] = useDeleteEventRecordingTranscribesMutation()

  const deleteEventRecordingTranscribes = useCallback(
    async (eventRecordingTranscribes: SelectedEventRecordingTranscribe[]) => {
      // 削除対象の文字起こしがない場合は削除リクエストは行わず処理を中断する
      if (eventRecordingTranscribes.length === 0) {
        return
      }

      // 削除対象の文字起こし行からリクエストパラメータを作成
      const deleteTargetTranscribes = eventRecordingTranscribes.map(
        (transcribe) => ({
          eventRecordingTranscribeId: transcribe.id,
          version: transcribe.version,
        })
      )

      // リクエストパラメータを設定
      const params: DeleteEventRecordingTranscribesRequest = {
        eventId: eventId,
        eventRecordingTranscribes: deleteTargetTranscribes,
      }

      // イベント録画文字起こし一括削除APIリクエスト
      await deleteEventRecordingTranscribesMutation(params).unwrap()

      const objectEventMessage: ObjectEventMessage<EventRecordingTranscribe> = {
        eventType: NotifyEventType.Deleted,
        id: eventRecordingTranscribes[0].id,
        object: undefined,
      }

      dispatch(notifyEventRecordingTranscribeEvent(objectEventMessage))
    },
    [deleteEventRecordingTranscribesMutation, dispatch, eventId]
  )

  return {
    deleteEventRecordingTranscribes,
    isLoadingDeleteTranscribes,
  }
}
